"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketingExperts = void 0;
var Card_1 = require("../Card");
var CardName_1 = require("../../CardName");
var Resources_1 = require("../../Resources");
var CardType_1 = require("../CardType");
var Tags_1 = require("../Tags");
var CardRenderer_1 = require("../render/CardRenderer");
var MarketingExperts = (function (_super) {
    __extends(MarketingExperts, _super);
    function MarketingExperts() {
        return _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.MARKETING_EXPERTS,
            tags: [Tags_1.Tags.EARTH],
            cost: 5,
            metadata: {
                cardNumber: 'A12',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.effect('When an ADJACENCY BONUS is collected from a tile you own, you gain 1 M€.', function (eb) {
                        eb.emptyTile().emptyTile('golden').startEffect.megacredits(1);
                    }).br;
                    b.production(function (pb) { return pb.megacredits(1); });
                }),
                description: 'Increase your M€ production 1 step.',
            },
        }) || this;
    }
    MarketingExperts.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.MEGACREDITS, 1);
        return undefined;
    };
    return MarketingExperts;
}(Card_1.Card));
exports.MarketingExperts = MarketingExperts;
